const SLIDE_DURATION_MS = 350;
const CAPTION_TRANSITION_DURATION_MS = 225;
const sliderWrapper = "_b7nswlxd9l";
const sliderContainer = "_b7ns19bixue";
const slider = "_b7ns1m30agp";
const imageCaptionWrapper = "_b7ni1xi25vq";
const imageCaptionTransition = "_b7ni1r88rje";

export { CAPTION_TRANSITION_DURATION_MS, SLIDE_DURATION_MS, imageCaptionTransition, imageCaptionWrapper, slider, sliderContainer, sliderWrapper };
import "./_slider.style.linaria.module.css";
//# sourceMappingURL=_slider.style.js.map
